export { default as Main } from './Main';
export { default as Minimal } from './Minimal';
export { default as Minimalistic } from './Minimalistic';
